import React, { useState, useEffect } from "react";
import { QRCodeSVG } from "qrcode.react";
import "../styles/deposit.css";

function Deposit() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await fetch(`${baseUrl}/wallet/balances`);
        if (!response.ok) {
          throw new Error("Failed to fetch users");
        }
        const data = await response.json();
        setUsers(data);
        setFilteredUsers(data);
        setIsLoading(false);
      } catch (error) {
        setError(error.message);
        setIsLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="home-page">
      <div className="price-section">
        <div className="coins-container">
          <input
            type="text"
            placeholder="Search username or email..."
            onChange={(e) => {
              const term = e.target.value.toLowerCase();
              setFilteredUsers(
                users.filter(
                  (u) =>
                    u.username.toLowerCase().includes(term) ||
                    u.email.toLowerCase().includes(term)
                )
              );
            }}
            style={{
              width: "100%",
              maxWidth: "400px",
              margin: "16px auto",
              padding: "12px",
              fontSize: "14px",
              border: "1px solid #cbd5e1",
              borderRadius: "8px",
              display: "block",
            }}
          />
          {/* Data Table */}
          <div className="table-container">
            {isLoading ? (
              <p className="loading">Loading...</p>
            ) : (
              filteredUsers.map((user, index) => (
                <div key={user.id || index} className="user-block">
                  <table className="data-table">
                    <tbody>
                      <tr>
                        <td>No:</td>
                        <td>{index + 1}</td>
                      </tr>
                      <tr>
                        <td>Username:</td>
                        <td>{user.username}</td>
                      </tr>
                      <tr>
                        <td>Email:</td>
                        <td>{user.email}</td>
                      </tr>
                      <tr>
                        <td>Balance:</td>
                        <td>
                          {parseFloat(user.balance).toFixed(2)}{" "}
                          <strong style={{ textTransform: "uppercase" }}>
                            {user.currency}
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>Currency:</td>
                        <td
                          style={{
                            textTransform: "uppercase",
                            fontWeight: 600,
                          }}
                        >
                          {user.currency}
                        </td>
                      </tr>
                      <tr>
                        <td>Create Date:</td>
                        <td>
                          {new Date(user.create_date).toLocaleDateString(
                            "en-US",
                            {
                              month: "numeric",
                              day: "numeric",
                              year: "numeric",
                            }
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Deposit;
